export default "dist/images/block-accordion-plain.e443b59.png";